import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'

export type PlanFeatureDetail = {
    featureId: string
    featureKey: string
    description: string
    unit: string
    features: (unknown | null)[]
}

export type PlanFeature = {
    planId: string
    featureId: string
    limitType: string
    limitInt: number
    limitDecimal: number
    resetPeriod: string
    pooledScope: string
    rollover: string
    gracePercent: number
    throttleAfter: number
    feature: PlanFeatureDetail
}

export type CreatePlanInput = {
    planId?: string
    planSku: string
    name: string
    description: string
    billingInterval: string
    isAddon?: boolean
    createdAt?: string
    updatedAt?: string
    features: PlanFeature[]
}

export const createPlan = (data: CreatePlanInput): Promise<any> => {
    return api.post('/v2/plans', data)
}

type UseCreatePlanOptions = {
    mutationConfig?: MutationConfig<typeof createPlan>
}

export const useCreatePlan = ({ mutationConfig }: UseCreatePlanOptions = {}) => {
    const queryClient = useQueryClient()
    const { onSuccess, ...restConfig } = mutationConfig || {}

    return useMutation({
        mutationFn: createPlan,
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['plans'] })
            onSuccess?.(...args)
        },
        ...restConfig,
    })
}


